import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { installSessionErrorCapture } from './app/theme/layouts/staff-assistant/error-buffer';
import { environment } from './environments/environment';

if (environment.production) {
	enableProdMode();
}

// Before bootstrap, so errors during start-up reach the staff help widget's feedback (in memory only).
if (environment.product === 'whitfields') installSessionErrorCapture();

platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.catch(err => {
		console.error(err);
	});
